import {Component, ElementRef, ViewChild} from '@angular/core';
import { MatButton } from '@angular/material/button';
import {MatDialogRef as MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-pin-dialog',
    templateUrl: './app-pin-dialog.component.html',
    styleUrls: ['./app-pin-dialog.component.scss']
})
export class AppPinDialogComponentMT {
  @ViewChild('submit') submitButton!: MatButton
    public header: string;
    public content?: string;

    public isSign: boolean = true;
    public pin: string = '';

    constructor(
        public dialogRefConfirm: MatDialogRef<AppPinDialogComponentMT>
    ) {
    }
    setFocus(){
      this.submitButton.focus()
    }
    pinEmit() {
        this.dialogRefConfirm.close({pin: this.pin});
    }
    cancelAction() {
        this.dialogRefConfirm.close({pin: null});
    }
}
